import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationDto } from '../types/notification-dto';
import { OeAppPersonService } from '../oe-app-person.service';

@Component({
  selector: 'lp2-new-level-congratulation-notification',
  template: `
    <lp2-end-of-level-congratulation
      [level]="level"
      title="endOfLevelNotification.title"
      subtitle="endOfLevelNotification.subtitle"
      body="endOfLevelNotification.body"
      buttonText="endOfLevelNotification.cta"
      (buttonPress)="ngbActiveModal.close()"
    ></lp2-end-of-level-congratulation>
  `,
  styleUrls: ['./new-level-congratulation-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewLevelCongratulationNotificationComponent {
  level: number;
  constructor(public ngbActiveModal: NgbActiveModal, private oeAppPersonService: OeAppPersonService) {
    this.level = oeAppPersonService.levelNum - 1;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/new-level-congratulation-notification/new-level-congratulation-notification.component.ts